import React, {useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Mixpanel } from '../redux/Mixpanel';
import { withRouter, useLocation } from 'react-router-dom';

import {
    IonButton,
    IonContent, IonGrid,
    IonInput, IonLabel, IonItem, IonImg, IonRow, IonCol,
    IonPage, IonList, IonText,
    IonIcon
} from '@ionic/react';

import { updateAuthorized} from '../redux/actions/authorization';
import { showLoading, showErrorModal, loginUser, logoutUser } from '../redux/actions';
import { UNIFORM_RESOURCE_LOCATORS } from '../utils/constants';
import { setLandlordLoggedIn, flushLoggedInUser } from '../utils/AuthUtils';
import { eye, eyeOff } from 'ionicons/icons';

const mapDispatchToProps = (dispatch) => ({
    updateAuthorizedtoTrue: () => dispatch(updateAuthorized(true)),
    logoutUser: () => dispatch(logoutUser()),
    showLoading: (value) => dispatch(showLoading(value)),
    showErrorModal: (error) => dispatch(showErrorModal(error)),
    loginUser: (username, password) => dispatch(loginUser(username, password))
});

const mapStateToProps = state => {
    return {};
}


function Login({history, updateAuthorizedtoTrue, showLoading, showErrorModal, loginUser, logoutUser}){

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [passwordValidity, setPasswordValidity] = useState({isValid: false, message: ""});
    const [showPassword, setShowPassword] = useState(false);
    const location = useLocation();
    const trimWhitespaceForSubmit = (value) => {
        if (typeof value !== 'string') return '';
        return value.trim();
    };
    const OFFLINE_LOGIN_MESSAGE = "No internet connection. Please check your connection and try again.";
    const INVALID_LOGIN_MESSAGE = "Invalid username or password";

    const getActionErrorMessage = (action) => {
        if (!action || !action.errors) return "";
        const { errors } = action;
        if (typeof errors === "string") return errors;
        if (Array.isArray(errors) && errors.length > 0) {
            if (typeof errors[0] === "string") return errors[0];
            if (errors[0] && typeof errors[0].message === "string") return errors[0].message;
        }
        if (errors?.message && typeof errors.message === "string") return errors.message;
        if (errors?.response?.data?.errors?.[0]?.message) return errors.response.data.errors[0].message;
        return "";
    };

    const isConnectivityFailure = (action) => {
        if (!action?.errors) return false;
        if (typeof action.errors === "string" || Array.isArray(action.errors)) return false;
        const message = getActionErrorMessage(action).toLowerCase();
        return (
            action.errors?.code === "ERR_NETWORK" ||
            action.errors?.name === "NetworkError" ||
            (action.errors?.isAxiosError === true && !action.errors?.response) ||
            message.includes("network error") ||
            message.includes("failed to fetch") ||
            message.includes("internet") ||
            message.includes("offline")
        );
    };

    // Used to clear redux state values. especially when user is redirected to
    // login page because of invalid/expired token.
    useEffect(() => {
        flushLoggedInUser();
        logoutUser();
    }, []);


    const validateAndRequestLogin = async (event) => {
        event.preventDefault();
        setPasswordValidity({isValid: true, message: ""});
        showLoading(true);
        //no need to validate if the fields are empty as the input fields are required in the form
        await RequestLogin();
    }

    const RequestLogin = async () => {

        try {
            const normalizedUsername = trimWhitespaceForSubmit(username).toLowerCase();
            const normalizedPassword = trimWhitespaceForSubmit(password);
            const action = await loginUser(normalizedUsername, normalizedPassword);
            findNextStep(action);
        } catch (error) {
            console.error(error);
            showLoading(false);
            showErrorModal(error);
        }
    }

    const findNextStep = (action) =>{
        showLoading(false);
        let searchParams = new URLSearchParams(location.search);
        if (action?.payload?.success === true) {
            const username = action.payload.user.username
            setLandlordLoggedIn();

            updateAuthorizedtoTrue();
            Mixpanel.identify(username);
            Mixpanel.track("Login page: Successful login");
            Mixpanel.people.set({
                $username: username
            })

            const redirectTo = location.redirectTo;

            if (searchParams.get('registeredUser') === 'true') {
                const nextPage = redirectTo && redirectTo!==UNIFORM_RESOURCE_LOCATORS.appLogin? redirectTo : UNIFORM_RESOURCE_LOCATORS.welcome;
                history.push({
                    pathname: nextPage,
                    search: ''
                })
                return;
            } else {
                const nextPage = redirectTo && redirectTo!==UNIFORM_RESOURCE_LOCATORS.appLogin? redirectTo: UNIFORM_RESOURCE_LOCATORS.dashboard;
                history.push({
                    pathname: nextPage,
                    search: ''
                })
                return;
            }

        } else {
            const errorMessage = isConnectivityFailure(action)
                ? OFFLINE_LOGIN_MESSAGE
                : getActionErrorMessage(action) || INVALID_LOGIN_MESSAGE;
            setPasswordValidity({isValid: false, message: errorMessage});
            Mixpanel.track("Login page: Unsuccessful login");
        }
    }


    return (


        <IonPage>
            <IonContent  fullscreen={true} >
            {/* Rest of your content */}
            <IonGrid style={{ height: "100%" }}>
                <IonRow class="ion-justify-content-center" style={{ height: "80%" }}>
                    <IonCol
                        sizeMd='6'
                        sizeSm='8'
                        sizeXs='12'
                        style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}
                    >

                    <IonImg
                        src="images/logos/BOMAHUT-purple.svg"
                        style={{'maxWidth':'300px', 'maxHeight':  '75px'}}

                        class='ion-margin'
                        alt="Bomahut Logo"
                    ></IonImg>

            <form autoComplete='on' style={{maxWidth: '400px'}} onSubmit={validateAndRequestLogin.bind(this)}>
                <IonList
                    class='ion-padding ion-margin'
                >
                <IonItem style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                    <IonInput
                        className={`${passwordValidity.isValid && 'ion-valid'} ${passwordValidity.isValid === false && 'ion-invalid'}`}
                        type="text"
                        autocomplete='username'
                        name="username"
                        id="username"
                        data-testid="username"
                        placeholder="Enter username"
                        label="username"
                        labelPlacement="floating"
                        clearInput={true}
                        value={username}
                        onIonInput={(e) => {
                            setUsername(e.detail.value ?? '')
                            setPasswordValidity({isValid: true, message: ""})
                        }}
                        required
                    />
                    {!passwordValidity.isValid && <IonText color="danger" className="ion-padding-start">
                        <small>{passwordValidity.message}</small>
                    </IonText>}
                </IonItem>

                <IonItem style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                    <IonInput
                        className={`${passwordValidity.isValid && 'ion-valid'} ${passwordValidity.isValid === false && 'ion-invalid'}`}
                        autocomplete='current-password'
                        name="password"
                        id="password"
                        data-testid="password"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter password"
                        label="password"
                        labelPlacement="floating"
                        value={password}
                        onIonInput={(e) => {
                            setPassword(e.detail.value ?? '')
                            setPasswordValidity({isValid: true, message: ""})
                        }}
                        required
                    />
                        <IonIcon size='small' className='pt-3 px-0' onClick={() => setShowPassword(!showPassword)} fill="clear" slot="end" icon={showPassword ? eye : eyeOff} />
                    {!passwordValidity.isValid && <IonText color="danger" className="ion-padding-start">
                        <small>{passwordValidity.message}</small>
                    </IonText>}
                </IonItem>
                </IonList>

                    <IonButton
                        expand='block'
                        class="ion-margin-horizontal ion-padding-horizontal"
                        data-testid="sign-in"
                        type="submit"
                        >
                            Sign In
                    </IonButton>


                </form>
                </IonCol>
                </IonRow>
            </IonGrid>
            </IonContent>
        </IonPage>
    )
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Login));
